import Vue from 'vue'
import App from './App.vue'

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
import $ from 'jquery'
Vue.prototype.$ = $;
import api from './api/index.js';
import store from "./store/index.js"
Vue.prototype.$api = api;
import '@/font/iconfont.css'
//导入路由组件
import router from './router/index.js'
Vue.use(router);
// 导入UI组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//导入router,同理, use school_db


//导入markdown
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
Vue.use(mavonEditor);

Vue.config.productionTip = false;
Vue.use(ElementUI, {
	size: 'medium'
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');